<template>
  <div class="learn-rate-component">
    <van-collapse v-model="activeName" icon="arrow" accordion change="change">
      <van-collapse-item v-for="(item, index) in dataList" :key="item.id" :name="(index + 1).toString()">
        <template #title>
          <div class="title" :class="{ unfold: activeName === (index + 1).toString() }">
            0{{ index + 1 }}
          </div>
          <template v-if="activeName === (index + 1).toString()">
            <div class="title-triangle-left"></div>
            <div class="title-triangle-right"></div>
          </template>
          <div class="title-top">第{{ item.CNNumeral }}阶段</div>
          <div class="title-bottom">{{ item.displayName }}</div>
          <div v-if="item.stateProgress != NaN " class="title-right">
            <van-circle v-if="!item.isHideCurrentRate" v-model="item.stateProgress" :speed="100" :rate="item.stateProgress" stroke-width="80" layer-color="#EAEAEA" :class="[item.stateProgress >= 100 ? 'circle-max' : 'circle-normal']" :color="item.stateProgress > 60 ? '#21bf52' : item.stateProgress > 30 ? '#fe6321' : '#ec3636'" :text="item.stateProgress + '%'" />
          </div>
          <div v-else class="title-right tr-font">未开启</div>
        </template>
        <div class="sub-stage">
          <div class="stage-name" :class="{ 'first-index': true }">
            {{ item.displayName }}
            <div class="stage-bottom-line"></div>
          </div>
        </div>
        <div class="sub-stage" v-for="(subNode, subIndex) in item.stageCourses" :key="subNode.id">
          <task-cell :task-data="subNode" :hide-bottom-line="subIndex === item.stageCourses.length - 1" v-bind="$attrs"></task-cell>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import TaskCell from './TaskCell.vue'
// import { numToCapital, NoToChinese } from '../../../utils/util'
import { NoToChinese } from '../../../utils/util'
export default {
  name: 'LearnRateComponent',
  components: {
    TaskCell
  },
  data() {
    return {
      dataList: [],
      currentStage: '1',
      activeName: '',
      activeNames: ['1', '2', '3', '4']
    }
  },
  props: {
    initData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    initData: {
      handler(newValue, oldValue) {
        if (newValue) {
          //   console.log('newValue', newValue)
          this.init()
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    init() {
      // 排序
      console.log('this.initData', this.initData)
      let arr = JSON.parse(JSON.stringify(this.initData))
      arr = arr.sort((a, b) => {
        return a.sequence - b.sequence
      })
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index]
        element.CNNumeral = NoToChinese(index + 1)
        if (element.learningRatePercent) {
          element.stateProgress = Number(element.learningRatePercent.replace(/[^\d.]/g, ''))
        } else {
          element.stateProgress = 0
        }
        if (element.stageCourses) {
          if (element.stageCourses.length > 1) {
            element.stageCourses = element.stageCourses.sort((a, b) => {
              return a.sequence - b.sequence
            })
          }
        } else {
          element.stageCourses = []
        }
      }
      this.dataList = JSON.parse(JSON.stringify(arr))
    }
  },
  mounted () {
    this.init()
  },
}
</script>

<style lang="less" scoped>
.learn-rate-component {
  border-radius: 5px;
  .sub-stage {
    .stage-name {
      position: relative;
      margin: -1px -12px 0;
      padding: 0 12px;
      font-size: 14px;
      // font-weight: bold;
      color: #656565;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 46px;
      line-height: 46px;
      border-top: 1px solid #e5e5e6;
      &.first-index {
        border-top: none;
      }
      .stage-bottom-line {
        position: absolute;
        bottom: 1px;
        width: 100%;
        height: 1px;
        background: #eeeeee;
      }
    }
  }

  /deep/ .el-progress-bar__outer {
    height: 7.5px !important;
  }
  /deep/ .el-progress--line {
    width: 217px;
    float: left;
    margin-top: 3px;
  }
  /deep/ .el-progress-bar__inner {
    background: #EB1700;
  }
  /deep/ .el-progress__text div {
    font-size: 13px;
    font-weight: 500;
    color: #fe6a23;
    margin-left: 6px;
  }
  .van-cell {
    padding: 0;
  }
  /deep/ .van-collapse-item {
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    margin-bottom: 15px;
  }
  /deep/ .van-collapse-item__title {
    height: 57px;
    overflow: inherit !important;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.13);
  }
  .title-triangle-left {
    position: absolute;
    bottom: -7px;
    left: -7px;
    width: 7px;
    height: 7px;
    background: #999999;
    background: linear-gradient(45deg, transparent, transparent 50%, #999 51%, #999 100%);
  }
  .title-triangle-right {
    position: absolute;
    bottom: -7px;
    right: 0;
    width: 7px;
    height: 7px;
    background: linear-gradient(-45deg, transparent, transparent 50%, #999 51%, #999 100%);
    z-index: 1;
  }
  .title-top {
    font-size: 12px;
    font-weight: 500;
    color: #666666;
    margin: -6px 25px;
  }
  .title-bottom {
    width: 220px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: bold;
    color: #1f333f;
    margin: 5px 0 0 24px;
  }
  .title-right {
    position: absolute;
    right: 45px;
    top: 10px;
  }
  /deep/ .van-circle__text {
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
  /deep/ .van-collapse-item,
  /deep/ .van-collapse-item__wrapper,
  /deep/ .van-collapse-item__title {
    background: white;
    border-radius: 8px;
  }
  /deep/ .van-collapse-item__title--expanded {
    overflow: auto;
    border-radius: 0 8px 0 0;
  }
  /deep/ .van-cell .title {
    background: #EB1700;
    color: #ffffff;
    border-radius: 8px 0 0 8px;
    position: absolute;
    // height: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    font-size: 20px;
    font-weight: bold;
    padding: 16.5px 6px;
    &.unfold {
      border-bottom-left-radius: 0;
    }
  }

  /deep/ .van-collapse-item__content {
    padding: 0 12px;
  }
  /deep/ .van-collapse-item__title--disabled .title {
    background: #e5e5e6;
    color: #666666;
    border-radius: 8px 0 0 8px;
  }
  /deep/ .van-badge__wrapper {
    display: flex;
    align-items: center;
    height: 100%;
  }
  /deep/ .van-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
  }

  .circle-max /deep/ .van-circle__text {
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
    font-size: 10px;
    transform: none;
  }
  .circle-normal /deep/ .van-circle__text {
    font-size: 12px;
    width: 118%;
    left: -3px;
  }
  .tr-font {
    line-height: 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/LearnRateComponent.vue